"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var debug_1 = __importDefault(require("debug"));
var debug = debug_1.default('app:utils:logReducerTiming');
function logReducerTiming(incomeReducers, thresholdInMs) {
    if (thresholdInMs === void 0) { thresholdInMs = 8; }
    var reducers = incomeReducers;
    if (process.env.NODE_ENV === 'production' ||
        typeof performance === 'undefined') {
        return reducers;
    }
    var reducerKeys = Object.keys(reducers);
    reducerKeys.forEach(function (name) {
        var originalReducer = reducers[name];
        if (!originalReducer) {
            console.error("Make sure the key \"" + name + "\" instance of reducers. Reducer keys: " + reducerKeys.join(', '));
            return;
        }
        reducers[name] = function (state, action) {
            var start = performance.now();
            var result = originalReducer(state, action);
            var diffInMs = performance.now() - start;
            if (diffInMs >= thresholdInMs) {
                debug("Reducer \"" + name + "\" took " + diffInMs.toFixed(2) + "ms to handle \"" + action.type + "\"");
            }
            return result;
        };
    });
    return reducers;
}
exports.default = logReducerTiming;
//# sourceMappingURL=logReducerTiming.js.map